'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addValidators;

var _extendsSchema = require('../schema/extendsSchema');

var _extendsSchema2 = _interopRequireDefault(_extendsSchema);

var _isInvisible = require('coact-utils/isInvisible');

var _isInvisible2 = _interopRequireDefault(_isInvisible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  empty value will still pass to validator, even for not required filed
  validator should handle empty value by itself
 */

function requiredValidator(value) {
  if ((0, _isInvisible2.default)(value)) return 'Value Required';
  return undefined;
}
function dateValidator(value) {
  if (Number.isNaN(Date.parse(value))) return 'Invalide Date';
  return undefined;
}
function numberValidator(value) {
  if (Number.isNaN(value)) return 'Not a Number';
  return undefined;
}

function composeValidator(validators) {
  return function (value) {
    var errors = validators.reduce(function (arr, validator) {
      var error = validator(value);
      if (error) arr.push(error);
      return arr;
    }, []);

    if (errors.length === 0) return undefined;
    return errors.join('_&_');
  };
}
function makeValidator(_ref) {
  var validator = _ref.validator,
      required = _ref.required,
      type = _ref.type;

  var validators = validator ? [].concat(validator) : [];

  if (required) validators.push(requiredValidator);
  if (type === 'Date') validators.push(dateValidator);
  if (type === 'Number') validators.push(numberValidator);

  if (validators.length === 0) return {};

  return {
    validator: function validator(value) {
      // let empty value pass for not required field
      if (!required && (0, _isInvisible2.default)(value)) return undefined;

      return composeValidator(validators)(value);
    }
  };
}

function addValidators(schema) {
  return (0, _extendsSchema2.default)(schema, makeValidator);
}


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/validation/addValidators.js
// module id = 1068
// module chunks = 0